var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgList = function SvgSvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.25 4.498a.75.75 0 0 1 0-1.5h15a.75.75 0 0 1 0 1.5zM8.25 13.498a.75.75 0 0 1 0-1.5h15a.75.75 0 0 1 0 1.5zM8.25 22.498a.75.75 0 0 1 0-1.5h15a.75.75 0 0 1 0 1.5zM1.5 5.998c-.827 0-1.5-.673-1.5-1.5v-3c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm0-1.5h3v-3h-3zM1.5 15C.673 15 0 14.327 0 13.5v-3C0 9.673.673 9 1.5 9h3c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm0-1.5h3v-3h-3zM1.5 23.998c-.827 0-1.5-.673-1.5-1.5v-3c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm0-1.5h3v-3h-3z"
  })));
};
export default SvgSvgList;